export default class Header {
  constructor() {
    this.internationalization();
  }

  internationalization() {
    const lang = localStorage.getItem("i18n_en");
    const langToggles = document.querySelectorAll("input[name='language']");
    const jpElements = document.querySelectorAll(".block-jp");
    const enElements = document.querySelectorAll(".block-en");
    const languageSwitching = (lang) => {
      jpElements.forEach((e) => {
        e.style.display = lang !== "1" ? "" : "none";
      });
      enElements.forEach((e) => {
        e.style.display = lang === "1" ? "" : "none";
      });
    };
    switch (lang) {
      case "1":
        localStorage.setItem("i18n_en", "1");
        document.querySelectorAll("input[id^='english']").forEach((element) => {
          element.checked = true;
        });

        break;
      default:
        localStorage.setItem("i18n_en", "0");
        document
          .querySelectorAll("input[id^='japanese']")
          .forEach((element) => {
            element.checked = true;
          });
    }
    languageSwitching(lang);
    langToggles.forEach((element) => {
      element.addEventListener("click", (event) => {
        const id = element.value;
        const flag = id.indexOf("english") === 0 ? "1" : "0";
        document.querySelectorAll(`input[id^='${id}']`).forEach((e) => {
          e.checked = true;
        });
        localStorage.setItem("i18n_en", flag);
        languageSwitching(flag);
      });
    });
  }
}
